export default __webpack_public_path__ + "8d697677d5a1c8eb2408a08d76111929.svg";